import React, { useEffect, useRef, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";
import { StaticImage } from "gatsby-plugin-image";
import BannerBg from "../../images/services-usa/hire-ios-app-developers/banner/bg.webp";

function Banner(props) {
  const [videoLoaded, setVideoLoaded] = useState(false);
  const [userInteracted, setUserInteracted] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const handleUserInteraction = () => {
      setUserInteracted(true);
    };

    const interactionEvents = [
      "click",
      "mousemove",
      "touchstart",
      "keydown",
      "scroll",
      "mouseover",
    ];

    interactionEvents.forEach((event) =>
      document.addEventListener(event, handleUserInteraction)
    );

    return () => {
      interactionEvents.forEach((event) =>
        document.removeEventListener(event, handleUserInteraction)
      );
    };
  }, []);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting && userInteracted) {
          setVideoLoaded(true);
          observer.disconnect(); // Stop observing once the video is loaded
        }
      },
      { threshold: 0.1 } // Adjust the threshold as needed
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (observer && sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, [userInteracted]);

  return (
    <div
      className="service_usa web_dev_service hire-ios-app-developers-banner"
      style={{ backgroundImage: `url(${BannerBg})` }}
      ref={sectionRef}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={7} lg={7} xl={7} xxl={6} className="my-auto">
            <div className="banenr_content">
              <h1 className="web_head_banner" style={{ marginBottom: "0px" }}>
                Hire Expert IOS App Developer in USA
              </h1>
              <span>Top-Tier iOS App Development</span>
              <p>
                Transform your business with expert iOS app developers,
                available for freelance and full-time roles. Our vetted
                developers deliver robust and user-friendly iOS applications
                made with a user-centric, scalable approach. With deep knowledge
                of iOS frameworks and evolving Apple devices, we ensure
                high-quality, cost-effective solutions. Accelerate your project
                timelines and boost customer engagement with custom applications
                that are secure and performant.
              </p>
              <Link
                to="/contact"
                className="border_btn"
                aria-label="Hire iOS Developers"
              >
                Hire iOS Developers
              </Link>
              <Link
                to="/contact"
                className="border_btn web_case_btn"
                aria-label="Discuss Project Needs"
              >
                Discuss Project Needs
              </Link>
            </div>
          </Col>
          <Col xs={12} md={5} lg={5} xl={5} xxl={6} className="">
            {videoLoaded ? (
              <>
                <div className="image">
                  <StaticImage
                    src="../../images/services-usa/hire-ios-app-developers/banner/bgbig.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={1623}
                    height={2118}
                  />
                </div>
              </>
            ) : (
              <>
                <div className="image">
                  <StaticImage
                    src="../../images/services-usa/hire-ios-app-developers/banner/banner.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={541}
                    height={706}
                  />
                </div>
              </>
            )}
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Banner;
